import { useState, useEffect, useContext } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContext, SttButtonAccept } from '../../../sporttia/all';
import { formatPriceByLocale, redirectLogin } from '../../../lib/utils';
import ModalSignUp from './ModalSignup';
import { useCrud } from '../../../lib/hooks';
import { getPath } from '../../Pages';

export default function EventDetails({
    event,
    team,
    onInscription,
    inscriptionDisabled,
}: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [signupCat, setSignupCat] = useState<any>(null);
    const [, , , Get, Post, ,] = useCrud(undefined, false);
    const [idMship, setIdMship] = useState<any>();

    function saveInscription(inscription: any) {
        cxt.api('POST', `/events/${event.id}/inscriptions`, {
            params: inscription,
            success: (response: any) => {
                if (
                    response.tpv ||
                    (response.inscription &&
                        response.inscription.payment &&
                        response.inscription.payment.tpv)
                ) {
                    const tpv =
                        response.tpv ||
                        (response.inscription &&
                            response.inscription.payment &&
                            response.inscription.payment.tpv);

                    navigate(getPath('tpvSwitcher', { id: tpv.id }));
                } else if (onInscription) {
                    onInscription();
                }

                setSignupCat(null);
            },
            error: (response: any) => {
                if (response.error) {
                    cxt.showMessage('E', response.error.msg);
                }
            },
        });
    }

    function addToTeam(idTeam: any, participants: any) {
        cxt.api('POST', '/batch', {
            params: {
                calls: participants.map((participant: any) => ({
                    method: 'POST',
                    endpoint: `/events/categories/${signupCat.id}/participants`,
                    data: { ...participant, idTeam },
                })),
            },
            success: () => {
                if (onInscription) {
                    onInscription();
                }
                setSignupCat(null);
            },
            error: (e: any) => {
                cxt.showMessage('E', e?.error?.msg);
                setSignupCat(null);
            },
        });
    }

    function saveTeam(teamInscription: any) {
        if (
            !teamInscription.participants ||
            teamInscription.participants.length === 0 ||
            !signupCat
        ) {
            return;
        }

        /* LA FORMA BUENA: No vale de momento porque "Call to undefined method APIEvent::addTeam() /home/sporttia/webs/sporttia-apis/pre/versions/v6/index.php [38]"
		if(!teamInscription.idTeam) {
			//crear equipo antes (?)
			Post(`/events/categories/${signupCat.id}/teams`, {name: teamInscription.teamName}).then(result => {
				if(result.team) {
					const {idTeam} = result.team;
					addToTeam(idTeam, teamInscription.participants);
				}
			}).catch(() => {})
		} else {
			addToTeam(teamInscription.idTeam, teamInscription.participants);
		}
		*/

        // console.log(teamInscription); return;

        // Chapuza: me inscribo yo primero y luego uso el idTeam generado para inscribir a los demás
        if (!teamInscription.idTeam) {
            const participants = [...teamInscription.participants];
            const me = participants.splice(
                participants.findIndex((p: any) => p.admin),
                1,
            );
            const { paymentForm, teamName } = teamInscription;

            Post(`/events/categories/${signupCat.id}/participants`, {
                ...me[0],
                paymentForm,
                teamName,
            })
                .then((response: any) => {
                    if (response.participant && response.participant.team) {
                        // Bug: si inscribo a más de uno a la vez, nunca entraremos aquí y por tanto no habrá pago con TPV
                        if (participants.length === 0) {
                            if (
                                response.tpv ||
                                (response.participant &&
                                    response.participant.enrollment &&
                                    response.participant.enrollment.tpv)
                            ) {
                                const tpv =
                                    response.tpv ||
                                    (response.participant &&
                                        response.participant.enrollment &&
                                        response.participant.enrollment.tpv);

                                navigate(
                                    getPath('tpvSwitcher', {
                                        state: { id: tpv.id },
                                    }),
                                );
                            } else {
                                if (onInscription) {
                                    onInscription();
                                }
                                setSignupCat(null);
                            }
                        } else {
                            addToTeam(
                                response.participant.team.id,
                                participants,
                            );
                        }
                    }
                })
                .catch((response: any) => {
                    if (response.error) {
                        cxt.showMessage('E', response.error.msg);
                    }
                });
        } else {
            addToTeam(teamInscription.idTeam, teamInscription.participants);
        }
    }

    function loadMe() {
        Get(`/scs/${event.sc.id}/me`)
            .then((response: any) => {
                if (response.mship) {
                    setIdMship(response.mship.id);
                }
            })
            .catch(() => {});
    }

    useEffect(() => {
        if (
            cxt.logged &&
            cxt.user?.role !== 'SPORTCENTER' &&
            event &&
            event.sc
        ) {
            loadMe();
        }
    }, [event]);

    if (!event) {
        return null;
    }

    const eventIsFull = event.teamable
        ? false
        : event.maxParticipants !== 0 &&
          event.numParticipants >= event.maxParticipants;

    return (
        <Box>
            <Box mb={3}>
                <div dangerouslySetInnerHTML={{ __html: event.description }} />
            </Box>
            <Box mb={3}>
                {/* MAX PARTICIPANTS */}
                {event.teamable ? (
                    <Typography variant="body1">{`${t('event.teams')}: ${
                        event.numTeams
                    }`}</Typography>
                ) : (
                    <Typography
                        variant="body1"
                        sx={{ color: eventIsFull ? '#f44336' : 'inherit' }}
                    >{`${t('event.participants')}: ${event.numParticipants}${
                        event.maxParticipants
                            ? ` / ${event.maxParticipants}`
                            : ''
                    }`}</Typography>
                )}
            </Box>
            <Box pt={3}>
                {/* LIST OF CATEGORIES */}
                {event.categories &&
                    event.categories.map((category: any, index: any) => {
                        const categoryIsFull = event.teamable
                            ? category.maxTeams !== 0 &&
                              category.numTeams >= category.maxTeams
                            : category.maxParticipants !== 0 &&
                              category.numParticipants >=
                                  category.maxParticipants;
                        const cur = event.teamable
                            ? category.numTeams
                            : category.numParticipants;
                        const max = event.teamable
                            ? category.maxTeams
                            : category.maxParticipants;

                        return (
                            <div key={index}>
                                {index > 0 && (
                                    <Box mt={3} mb={2}>
                                        <Divider />
                                    </Box>
                                )}
                                <Box p={1}>
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                    >
                                        <Typography variant="h6">
                                            {category.name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: categoryIsFull
                                                    ? '#f44336'
                                                    : 'inherit',
                                            }}
                                        >
                                            {`${cur}${
                                                max !== 0 ? ` / ${max}` : ''
                                            } ${
                                                event.teamable
                                                    ? t(
                                                          'event.teams',
                                                      ).toLowerCase()
                                                    : t(
                                                          'event.participants',
                                                      ).toLowerCase()
                                            }`}
                                        </Typography>
                                    </Box>
                                    {category.description && (
                                        <Box p={1}>
                                            <Typography variant="body2">
                                                {category.description}
                                            </Typography>
                                        </Box>
                                    )}
                                    <Box
                                        mt={3}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Typography variant="body1">{`${t(
                                            'event.inscription',
                                        )}: ${
                                            category.enrollment > 0
                                                ? formatPriceByLocale(
                                                      category?.enrollment,
                                                      category?.enrollmentShape
                                                          ?.currency,
                                                      category?.enrollmentShape
                                                          ?.locale,
                                                  )
                                                : t('payment.free')
                                        }`}</Typography>
                                        {event.signupOnline && (
                                            <SttButtonAccept
                                                disabled={
                                                    inscriptionDisabled ||
                                                    eventIsFull ||
                                                    categoryIsFull
                                                }
                                                caption={t('activity.signUp')}
                                                onClick={() =>
                                                    cxt.logged
                                                        ? setSignupCat(category)
                                                        : redirectLogin(
                                                              navigate,
                                                              location,
                                                          )
                                                }
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </div>
                        );
                    })}
            </Box>
            {signupCat && (
                <ModalSignUp
                    event={event}
                    team={team}
                    category={signupCat}
                    onSaveTeam={saveTeam}
                    onSaveInscription={saveInscription}
                    onClose={() => setSignupCat(null)}
                    idMship={idMship}
                />
            )}
        </Box>
    );
}
